exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[pagination]{text-align:center}[pagination] a{display:inline-block;vertical-align:middle;width:3.33333333rem;height:3.33333333rem;border:1px solid #e6e6e6;font-size:1.25rem;line-height:1.4;line-height:3.33333333rem;font-weight:700}[pagination] a.on{color:#fff;background:#464d5d;border-color:#464d5d}[pagination] a.next,[pagination] a.prev{background-image:url(\"/static/img/common/paging-l.png\");background-repeat:no-repeat;background-position:50%}[pagination] a.end,[pagination] a.first{background-image:url(\"/static/img/common/paging-ll.png\");background-repeat:no-repeat;background-position:50%}[pagination] a.end,[pagination] a.next{-webkit-transform:rotate(180deg);transform:rotate(180deg)}[pagination] a.prev{margin-right:10px}[pagination] a.next{margin-left:10px}[pagination] a.disabled{opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00fdcebe","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/Pagination.vue
// module id = sRKD
// module chunks = 241